import styled from "styled-components";
import { Link } from "react-router-dom";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import globalStyles from "../../constants/globalStyles/theme.json";

const { colors } = globalStyles;

export const StyledButtonLink = styled(Link)`
  text-decoration: none;
  position: relative;
  color: inherit;
  display: inline-flex;
  align-items: center;

  &::after {
    content: "";
    display: block;
    width: 100%;
    height: 2px;
    background-color: ${colors.primary.green};
    position: absolute;
    bottom: -2px;
    left: 0;
  }

  svg {
    transition: transform 0.3s ease;
  }

  &:hover {
    text-decoration: none;

    svg {
      transform: translateX(5px);
    }
  }
`;

export const AnimatedIcon = styled(ArrowForwardIcon)`
  transition: transform 0.3s ease;
`;
